"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._RequestProgress = {
    type: "structure",
    required: [],
    members: {
        Enabled: {
            shape: {
                type: "boolean"
            }
        }
    }
};
//# sourceMappingURL=_RequestProgress.js.map